import React from 'react'
import imageUrl from "utils/imageUrl";
const About = () => {
  return (
    <>
   <section id="about">
    <div className="cs-height_100"></div>
    <div className="container">
        <div className="row align-items-center flex-column-reverse-lg">
            <div className="col-lg-6">
                <div className="cs-height_0 cs-height_04_lg"></div>
                <div className="cs-right_space_40">
                <div className="cs-section_heading">
                   <h3 className="cs-section_title">SIMPLE STEPS</h3>
                   <h2 className="cs-section_subtitle">ABOUT US</h2>
                   <div className="cs-height"></div>   
                   <p className='text'>
                   Welcome to our NFT collection! We are a group of passionate artists and creators who have come together to showcase our unique and diverse styles through the medium of non-fungible tokens. Our collection features a wide range of digital art pieces, each one carefully crafted to capture the essence of our individuality and creativity. With a focus on innovation and pushing the boundaries of what is possible with digital art, we are excited to share our collection with the world. </p>
                   <p className='text'>Each NFT in our collection is a one-of-a-kind piece that represents not only our art but also our collective vision and dedication to creating a vibrant and dynamic community of NFT enthusiasts. We hope you enjoy exploring our collection and discovering the magic of digital art through our unique perspectives.</p>   
                 </div>
                </div>
            </div>
            <div className="col-lg-6">
                <img src={imageUrl("about_img.jpg")} alt="" srcset="" />
            </div>
        </div>
    </div>
     
   </section>
   </>
  )
}

export default About